import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar'; 
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetService} from '../services/timesheetService';
import {formatterhelper} from '../helpers/dateformatter';
import {loader} from '../compnents/loadermd';
import {dataExporthelper} from '../helpers/exporthelper';
import { Toast } from 'primereact/toast';

const Rdsreports = () => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        fromdate: '',
        todate: '',
        manager: '',
        managername: '',
        employee: 'ALL',
        
      });
    const [loadercomp,setloadecomp] = useState(null);  
    const [datacomp,setDatacomp] = useState([]); 
    const [manager,setmanger] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [isloaded,setloaded] = useState(true); 
    const [managerscomp,setmanagercomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [currentuser,setUser] = useState(''); 
    const [break_time,setBreaktime] = useState('');
    const [rdsdata,setRdsData] = useState({'currentuser':'','break_time':''});
    const [errors, setErrors] = useState({});

    const [dataexport, setdataexport] = useState(false);
    const [selectedEmployeeName, setSelectedEmployeeName] = useState('');

    useEffect(()=>{
        // getemplist();
        // _getclientslist();
        getmanagerlist();
        
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        
        if(name == 'manager'){
            const managerDisplayName = e.target.options[e.target.selectedIndex]?.text || '';
            setmanger(value);
            setFormData((prevData) => ({
                ...prevData,
                manager: value,
                managername: managerDisplayName,
            }));
            _getemplist({managerid:value});
        }

        if(name == 'employee'){
            const empDisplayName = e.target.options[e.target.selectedIndex]?.text || '';
            setSelectedEmployeeName(value === 'ALL' ? '' : empDisplayName);
        }
         
      };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
        if (formData.fromdate == '') {
          newErrors.fromdate = 'From date is required';
          valid = false;
        }

        if (formData.todate == '') {
            newErrors.todate = 'To date is required';
            valid = false;
        }
        
        if (formData.manager == '') {
            newErrors.manager = 'Manager is required';
            valid = false;
        }

        // if (formData.managername == '') {
        //     newErrors.managername = 'Budgethours name is required';
        //     valid = false;
        // }

        // if (formData.employee == '') {
        //     newErrors.employee = 'Budgethours name is required';
        //     valid = false;
        // }

        setErrors(newErrors);

       return valid; 
    }  

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
        }
       
        // console.log(formData);  
        let rdsobj =  {
            emp_id: formData.employee,
            fromdate: formatterhelper.dateformatter({date:formData.fromdate}),
            todate: formatterhelper.dateformatter({date:formData.todate}),
            manager_id:formData.manager,     
        }  
       //console.log(rdsobj);
       getrdsreports(rdsobj)
        // getreports(reportobj);
      };

    function deleterds(obj){
        timesheetreportService.deleterds(obj.id).then((response)=>{
             if(response.status == 200){
                  toast.current.show({severity:'success', summary: "Rds", detail:`${response.data.data} `, life: 3000}); 
                  let rdsobj =  {
                        emp_id: formData.employee,
                        fromdate: formatterhelper.dateformatter({date:formData.fromdate}),
                        todate: formatterhelper.dateformatter({date:formData.todate}),
                        manager_id:formData.manager,     
                    } 
                  getrdsreports(rdsobj);
             }else{
                  toast.current.show({severity:'error', summary: "Rds", detail:`${response.data.data} `, life: 3000}); 
             }
        }).catch((error)=>{
             toast.current.show({severity:'error', summary: "Rds", detail:`Error`, life: 3000}); 
        }); 
    }  

    function getrdsreports(reportobj){  
        let emparr = [];
        setloaded(false);
        timesheetreportService.rdsshow_report({obj:reportobj})
        .then((response)=>{
            if(response.status == 200){
                response.data.data.alldata.forEach((value,index) =>{
                    emparr.push((<tr>
                        <td>{value.employeecode}</td>
                        <td>{value.empname}</td>
                        <td>{value.date_time}</td>
                        <td>{value.new_logontime}</td>
                        <td>{value.new_logofftime}</td>
                        <td>{value.lontime_formated}</td>
                        <td>{value.workingtime_minutes}</td>
                        <td>{value.break_time}</td>
                        <td>{value.total_time}</td>
                        {userdata.roletype == 'admin' ? (<td><button className='btn btn-danger' onClick={()=>{deleterds(value)}}>Del</button></td>) : (<></>)}
                    </tr>));
                }); 
                setDatacomp(emparr);
                setDatastate(true);
                setloaded(true);
                setUser(response.data.data.currentuser);
                setBreaktime(response.data.data.break_time);
                setRdsData(response.data.data);
            }else{
                setDatacomp([]);  
                setDatastate(false);
                setloaded(true);
                 toast.current.show({ severity: 'error', summary: 'RDS Report', detail: response.data.data, life: 3000 });
            }
        }).catch((error)=>{
            console.log(error);
            setDatacomp([]);  
            setDatastate(false);
        });
    }  

    function getmanagerlist(){
        let emparr = [];
        timesheetreportService.getmangrlist().then((response)=>{
           console.log('get manager list');
           console.log(response);
           response.data.data.forEach((value,index) =>{
              emparr.push((<option value={value.id}>{value.name}</option>));
           });
           setmanagercomp(emparr);
        }).catch((error)=>{

        });  
    }

    function _getemplist({managerid}){
        // let managerid = 1;
        let emparr = [];
        timesheetreportService.getemployeelist({managerid:managerid}).then((response)=>{
            console.log(response);
            response.data.data.forEach((value,index) =>{
                emparr.push((<option value={value.id}>{value.name}</option>));
            });
            setempcomp(emparr);
         }).catch((error)=>{
 
         });    
    }

    function exporttoexcelrdsreport(){
        setdataexport(true);
        let rdsobj =  {
            emp_id: formData.employee,
            fromdate: formatterhelper.dateformatter({date:formData.fromdate}),
            todate: formatterhelper.dateformatter({date:formData.todate}),
            manager_id:formData.manager,     
        } 

        timesheetreportService.export_rds_report({obj:rdsobj}).then((response)=>{
            if(response.status == 200){
                 exporttoexcel(response.data.data.alldata);
                 setdataexport(false);
             }else{
                 toast.current.show({ severity: 'error', summary: 'RDS Report', detail: response.data.data, life: 3000 });
                 setdataexport(false);

             }
        }).catch((error)=>{
            console.log(error);
            setdataexport(false);
        });
    }


    function exporttoexcel(data){
        // dataExporthelper.exportFromhtml({id:'rdsreportid'}); 
        dataExporthelper.exportToExcel(data,{filename:'rds_Reportsexcel_from:'+formData.fromdate});
    }

    return (
        <>
            <Toast ref={toast}/>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-2">
                        <label className='pull-left'>From date</label>
                        <Calendar value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                        {errors.fromdate && <span className='error'>{errors.fromdate}</span>}
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>To date</label>
                        <Calendar value={formData.todate} name="todate" onChange={handleChange} className='calender-custom-style' />
                        {errors.todate && <span className='error'>{errors.todate}</span>}
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Manager</label>
                        <select className='form-control' name="manager" value={formData.manager} onChange={handleChange}>
                            <option value=''>Select Manager</option>
                            <option value='ALL'>ALL</option>
                            {managerscomp}
                        </select>
                        {errors.manager && <span className='error'>{errors.manager}</span>}
                    </div> 

                    <div className="col-md-2">
                        <label className='pull-left'>Select Employee</label>
                        <select className='form-control' name="employee" value={formData.employee} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {empcomp}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                            &nbsp;&nbsp;&nbsp; 

                            {dataexport ?  <Button type='button' stype="button" label="Exporting ..." severity="info" onClick={()=> {}} rounded className='custom-btn-style' />:  <Button type='button' stype="button" label="Export" severity="info" onClick={()=> exporttoexcelrdsreport()} rounded className='custom-btn-style' />}
                           
                        </div>

                    </div>
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
                {/* <div className='row'>
                    <div className='pagination-style'>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination">
                                <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                                <li class="page-item"><a class="page-link" href="#">1</a></li>
                                <li class="page-item"><a class="page-link" href="#">2</a></li>
                                <li class="page-item"><a class="page-link" href="#">3</a></li>
                                <li class="page-item"><a class="page-link" href="#">Next</a></li>
                            </ul>
                            </nav>
                    </div>
                </div> */}
                <div className='row'>
                   <div className='col-md-8'>
                    { !isloaded ? loader.Loadermd() : dataavail ?

                    (<table class="table table-bordered" id="rdsreportid">
                        <thead>
                            <tr>
                                <th>Emp Code</th>   
                                <th scope="col">Employee Name</th>
                                <th scope="col">Date</th>
                                <th scope="col">Log in time</th>
                                <th scope="col">Log off time</th>
                                <th scope="col">Work</th>
                                <th scope="col">Work (Min)</th>
                                <th scope="col">Break</th>
                                <th scope="col">Total</th>
                                {userdata.roletype == 'admin' ? (<th scope="col">Action</th>) : (<></>)}
                                
                            </tr>
                        </thead>
                        <tbody>
                            {datacomp}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                    <div className='col-md-4'>
                    <div class="rds_detail_container">
                        {/* Profile Header */}
                        <div style={{ background:'linear-gradient(135deg,#667eea 0%,#764ba2 100%)', padding:'28px 20px 22px', textAlign:'center' }}>
                            <div style={{ width:'58px', height:'58px', borderRadius:'50%', background:'rgba(255,255,255,0.22)', border:'3px solid rgba(255,255,255,0.55)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 12px', fontSize:'22px', fontWeight:700, color:'#fff' }}>
                                {rdsdata.currentuser ? rdsdata.currentuser.charAt(0).toUpperCase() : '?'}
                            </div>
                            <div style={{ color:'#fff', fontWeight:700, fontSize:'16px', letterSpacing:'0.3px' }}>{rdsdata.currentuser || '—'}</div>
                            {/* <div style={{ color:'rgba(255,255,255,0.75)', fontSize:'12px', marginTop:'4px', fontWeight:500 }}>Employee1</div> */}
                        </div>

                        {/* Info Rows */}
                        <div style={{ padding:'4px 20px 12px' }}>
                            <div style={{ display:'flex', alignItems:'center', padding:'12px 0', borderBottom:'1px solid #f3f4f6' }}>
                                <span style={{ color:'#9ca3af', fontSize:'11px', fontWeight:700, letterSpacing:'0.6px', width:'88px', flexShrink:0 }}>LOG IN</span>
                                <span style={{ color:'#111827', fontWeight:600, fontSize:'14px' }}>{rdsdata.new_logontime || '—'}</span>
                            </div>
                            <div style={{ display:'flex', alignItems:'center', padding:'12px 0', borderBottom:'1px solid #f3f4f6' }}>
                                <span style={{ color:'#9ca3af', fontSize:'11px', fontWeight:700, letterSpacing:'0.6px', width:'88px', flexShrink:0 }}>LOG OFF</span>
                                <span style={{ color:'#111827', fontWeight:600, fontSize:'14px' }}>{rdsdata.new_logofftime || '—'}</span>
                            </div>
                            <div style={{ display:'flex', alignItems:'center', padding:'12px 0', borderBottom: selectedEmployeeName ? '1px solid #f3f4f6' : 'none' }}>
                                <span style={{ color:'#9ca3af', fontSize:'11px', fontWeight:700, letterSpacing:'0.6px', width:'88px', flexShrink:0 }}>MANAGER</span>
                                <span style={{ color:'#111827', fontWeight:600, fontSize:'14px' }}>{formData.managername || '—'}</span>
                            </div>
                            {selectedEmployeeName ? (
                                <div style={{ display:'flex', alignItems:'center', padding:'12px 0' }}>
                                    <span style={{ color:'#9ca3af', fontSize:'11px', fontWeight:700, letterSpacing:'0.6px', width:'88px', flexShrink:0 }}>EMPLOYEE</span>
                                    <span style={{ color:'#111827', fontWeight:600, fontSize:'14px' }}>{selectedEmployeeName}</span>
                                </div>
                            ) : null}
                        </div>

                        {/* Metric Tiles */}
                        <div style={{ display:'flex', gap:'10px', padding:'0 16px 20px' }}>
                            <div style={{ flex:1, background:'#f0fdf4', borderRadius:'10px', padding:'14px 8px', textAlign:'center', border:'1px solid #bbf7d0' }}>
                                <div style={{ fontSize:'17px', fontWeight:700, color:'#15803d' }}>{rdsdata.logonn || '—'}</div>
                                <div style={{ fontSize:'10px', color:'#6b7280', marginTop:'5px', fontWeight:700, letterSpacing:'0.5px' }}>WORK</div>
                            </div>
                            <div style={{ flex:1, background:'#fff7ed', borderRadius:'10px', padding:'14px 8px', textAlign:'center', border:'1px solid #fed7aa' }}>
                                <div style={{ fontSize:'17px', fontWeight:700, color:'#c2410c' }}>{rdsdata.break_time || '—'}</div>
                                <div style={{ fontSize:'10px', color:'#6b7280', marginTop:'5px', fontWeight:700, letterSpacing:'0.5px' }}>BREAK</div>
                            </div>
                            <div style={{ flex:1, background:'#eff6ff', borderRadius:'10px', padding:'14px 8px', textAlign:'center', border:'1px solid #bfdbfe' }}>
                                <div style={{ fontSize:'17px', fontWeight:700, color:'#1d4ed8' }}>{rdsdata.logonn || '—'}</div>
                                <div style={{ fontSize:'10px', color:'#6b7280', marginTop:'5px', fontWeight:700, letterSpacing:'0.5px', lineHeight:'1.4' }}>TIMESHEET<br/>HRS</div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Rdsreports;